export const truncateTo1Decimal = (value?: number) => {
  if (value === undefined || value === null) return value;
  if (!Number.isFinite(value)) return value;
  return Math.trunc(value * 10) / 10;
};
